import type { ClaimsVolumeTrendResponse, Top5Response } from "@broadview/api-client";

export type HistoricalFailureModeRow = Readonly<{
  rank: number;
  name: string;
  shortName: string;
  claimCount: number;
  cumulativePercent: number;
}>;

export function buildHistoricalFailureModeRows(
  top5: Top5Response,
  claimsVolume: ClaimsVolumeTrendResponse,
): HistoricalFailureModeRow[] {
  const widget = top5.widgets.find(({ payload }) => payload.category === "failure_modes");
  const total = claimsVolume.series.find(({ metricId }) => metricId === "K002")?.total;
  if (!widget || widget.dataState === "UNAVAILABLE" || !total || total <= 0) return [];

  const governed = widget.payload.items
    .filter(
      (item) =>
        item.dataState !== "SYNTHETIC" &&
        item.authorityClass !== "DEMONSTRATION_ONLY" &&
        item.claimCount !== undefined,
    )
    .sort((left, right) => left.rank - right.rank);

  let cumulative = 0;
  return governed.map((item) => {
    cumulative += item.claimCount!;
    return {
      rank: item.rank,
      name: item.title,
      shortName: item.title.length > 24 ? `${item.title.slice(0, 21)}…` : item.title,
      claimCount: item.claimCount!,
      cumulativePercent: Number(((cumulative / total) * 100).toFixed(1)),
    };
  });
}
